import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { H7 } from 'foundations-components/transitional/components/H7';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { Divider } from './insertMenu/InlineInsertHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GenericPopoverHeader = ({
  portalId,
  manageUrl,
  onClickManageButton,
  onViewInsertMenu,
  titleMessage,
  getNewLinkUrl
}) => /*#__PURE__*/_jsxs(H7, {
  paddingInline: "400",
  marginBlockEnd: "300",
  display: "flex",
  alignItems: "center",
  children: [/*#__PURE__*/_jsx(IconButton, {
    use: "link",
    "data-test-id": "insert-menu-back-button",
    onClick: e => onViewInsertMenu ? onViewInsertMenu(e) : null,
    children: /*#__PURE__*/_jsx(LeftIcon, {})
  }), /*#__PURE__*/_jsx(Divider, {
    as: "span"
  }), /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    inlineSize: "100%",
    children: [titleMessage, /*#__PURE__*/_jsxs("div", {
      children: [getNewLinkUrl && /*#__PURE__*/_jsx(Button, {
        external: true,
        href: getNewLinkUrl(portalId),
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.snippetsPlugin.popover.header.createNew"
        })
      }), manageUrl && /*#__PURE__*/_jsx(Button, {
        external: true,
        href: manageUrl,
        size: "extra-small",
        use: "tertiary-light",
        onClick: onClickManageButton,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.snippetsPlugin.popover.header.manage"
        })
      })]
    })]
  })]
});
GenericPopoverHeader.propTypes = {
  manageUrl: PropTypes.string,
  portalId: PropTypes.number.isRequired,
  onClickManageButton: PropTypes.func,
  onViewInsertMenu: PropTypes.func,
  titleMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  getNewLinkUrl: PropTypes.func
};
export default GenericPopoverHeader;